import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import {
	WarmupDataAggregatorSymbol,
	WarmupDataEnricherSymbol,
	WarmupDataProviderSymbol,
	WarmupDataServiceStoreSymbol,
} from './symbols'
import { WarmupDataProvider } from './warmupDataProvider'
import { WarmupDataAggregator } from './warmupDataAggregator'
import { WarmupDataService } from './warmupDataService'
import { WarmupDataServiceStore } from './warmupDataServiceStore'

export const site: ContainerModuleLoader = (bind) => {
	bind(WarmupDataProviderSymbol).to(WarmupDataProvider)
	bind(ServiceProviderSymbol).to(WarmupDataService)

	if (!process.env.browser) {
		bind(WarmupDataServiceStoreSymbol, WarmupDataEnricherSymbol).to(WarmupDataServiceStore)
		bind(WarmupDataAggregatorSymbol).to(WarmupDataAggregator)
	}
}

export const editor: ContainerModuleLoader = (bind) => {
	bind(WarmupDataProviderSymbol).to(WarmupDataProvider)
	bind(ServiceProviderSymbol).to(WarmupDataService)
}

export {
	WARMUP_DATA_SERVICE_DATA_KEY,
	WarmupDataAggregatorSymbol,
	WarmupDataProviderSymbol,
	WarmupDataEnricherSymbol,
	WarmupDataPromiseSymbol,
	WarmupDataServiceStoreSymbol,
} from './symbols'
export type {
	BuilderComponentsWarmupData,
	IWarmupDataEnricher,
	IWarmupDataAggregator,
	IWarmupDataProvider,
	IWarmupDataServiceStore,
	WarmupDataServiceWarmupData,
} from './types'
